/**
 * ObjectiveStatusBadge
 *
 * Pequeña pill que comunica el estado de la campaña en una sola línea.
 * Usa STATUS_META centralizado para mantener consistencia visual entre
 * lista, card y dashboard.
 */

import { STATUS_META } from "../api";
import type { ObjectiveStatus } from "../types";

interface ObjectiveStatusBadgeProps {
  status: ObjectiveStatus;
  size?: "sm" | "md";
}

export function ObjectiveStatusBadge({
  status,
  size = "sm",
}: ObjectiveStatusBadgeProps) {
  const meta = STATUS_META[status];

  const padding = size === "sm" ? "px-2 py-0.5" : "px-3 py-1";
  const text = size === "sm" ? "text-[10px]" : "text-xs";

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold uppercase tracking-wider ${padding} ${text} ${meta.classes}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dotClass}`} />
      {meta.label}
    </span>
  );
}

export default ObjectiveStatusBadge;
